import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-72742ae3")

_pushScopeId("data-v-72742ae3")
const _hoisted_1 = { class: "flex" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_button = _resolveComponent("el-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_input, {
      placeholder: _ctx.placeholder,
      modelValue: _ctx.keyword,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.keyword = $event)),
      onKeydown: _withKeys(_withModifiers(_ctx.search, ["stop"]), ["enter"])
    }, null, 8, ["placeholder", "modelValue", "onKeydown"]),
    _createVNode(_component_el_button, {
      class: "search-button",
      type: "success",
      icon: "el-icon-search",
      onClick: _ctx.search
    }, null, 8, ["onClick"])
  ]))
})